import { axiosInstance } from "./config";

const BASE_URL = "/asset";

/* ================= CREATE ================= */
export const createAsset = (data) =>
  axiosInstance.post(`${BASE_URL}/create`, data);

/* ================= GET ALL ================= */
export const getAllAssets = () =>
  axiosInstance.get(`${BASE_URL}/all`);

/* ================= GET ONE (OPTIONAL) ================= */
export const getAssetById = (id) =>
  axiosInstance.get(`${BASE_URL}/${id}`);

/* ================= UPDATE ================= */
export const updateAsset = (id, data) =>
  axiosInstance.put(`${BASE_URL}/${id}`, data);

/* ================= DELETE ================= */
export const deleteAsset = (id) =>
  axiosInstance.delete(`${BASE_URL}/${id}`);